import React, { useState, useEffect } from 'react'
import { Box, Typography } from '@mui/material'
import _ from 'lodash'
import { Breadcrumb, Cards, Loader, DisplayMessage } from '../../components'
import { customerService } from '../../services/CustomerServices'
import * as messageTypes from '../../utils/messageTypes'
import ApplicationList from './ApplicationList'
import ApplicationDetails from './ApplicationDetails'
import { useStyles } from './style'
import history from '../../routes/history'
import { dashboardService } from '../../services/DashboardService'
import { navToLogin } from '../../utils/common'
import { FAMILY_KEY } from '../../constants/common'
import { applicationsService } from '../../services'

function ApplicationTracker(props) {
  const classes = useStyles()
  const search = _.get(props.location, 'search', {})
  const params = _.get(props.match, 'params', {})
  const ids = new URLSearchParams(search).get('program')
  const programId = _.get(params, 'programId', '')
  const [programName, setProgramName] = useState('')
  const [programKey, setProgramKey] = useState('')
  const [familyKey, setFamilyKey] = useState('')
  const [workflow, setWorkflow] = useState('')
  const [applicationId, setApplicationId] = useState('')
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState('')
  const [messageType, setMessageType] = useState('')
  const [applicationListDetails, setApplicationListDetails] = useState({})
  const [applicationDetails, setApplicationDetails] = useState({})
  const [applicationStatus, setApplicationStatus] = useState('')
  const [utilityName, setUtilityName] = useState('')
  const [csPrograms, setCsProgram] = useState([])
  const [programIds, setProgramIds] = useState([])

  useEffect(() => {
    if (csPrograms.length > 0) {
      const selectedApplicationProgram = csPrograms.find(obj => obj.id === _.get(applicationDetails, 'program_id', ''))
      setUtilityName(_.get(selectedApplicationProgram, 'utility_name', ''))
    }
  }, [applicationDetails])

  const getProgramDetails = () => {
    setLoading(true)
    dashboardService.getAllPrograms()
      .then(programsData => {
        setLoading(false)
        const filteredPrograms = programsData.filter(program => program.feature_flags && program.feature_flags.customer_support_verification)
        const selectedApplicationProgram = filteredPrograms.find(obj => obj.id === programIds[0])
        setCsProgram(filteredPrograms)
        setFamilyKey(_.get(selectedApplicationProgram, 'family_key', ''))
        setProgramName(_.get(selectedApplicationProgram, 'name', ''))
        setProgramKey(_.get(selectedApplicationProgram, 'program_key', ''))
        setWorkflow(_.get(selectedApplicationProgram, 'workflow', ''))
      })
      .catch(error => {
        setLoading(false)
        errorCb(error)
      })
  }

  useEffect(() => {
    if (programId) {
      setLoading(true)
      applicationsService.getAllProgramIds(programId, false)
        .then(programsData => {
          let idsList = []
          programsData.forEach(program => {
            idsList.push(program.id)
          })
          setProgramIds(idsList)
        })
        .catch(error => {
          setLoading(false)
          setOpen(true)
          setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
          setMessageType(messageTypes.ERROR)
        })
    }
  }, [])

  useEffect(() => {
    (programIds.length > 0) && getProgramDetails()
  }, [programIds])

  const errorCb = (error) => {
    setOpen(true)
    setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
    setMessageType(messageTypes.ERROR)
  }

  const successCb = (message, status) => {
    setOpen(true)
    setMessage(message)
    setMessageType(messageTypes.SUCCESS)
    setApplicationStatus(status)
  }

  const getApplicationDetail = (applicationId, id) => {
    const applicationProgramId = id ? id : programId
    setLoading(true)
    customerService.getApplicationsById(applicationProgramId, applicationId)
      .then(response => {
        setApplicationDetails(response)
        setLoading(false)
      })
      .catch(error => {
        setLoading(false)
        errorCb(error)
      })
  }

  const cbSuccess = (response) => {
    setLoading(false)
    setApplicationListDetails(response)
  }

  const cbError = (error) => {
    setLoading(false)
    if (error.status === 403) {
      navToLogin()
    } else {
      errorCb(error)
    }
  }

  const getApplicationList = (pageNum, filter) => {
    setLoading(true)
    if (programIds.length > 0) {
      if (familyKey === FAMILY_KEY.CT_ESS) {
        customerService.getApplicationbyMultipleId(programIds, pageNum, filter)
          .then(response => {
            cbSuccess(response)
          })
          .catch(error => {
            cbError(error)
          })
      } else {
        customerService.getApplicationsByProgramId(programIds[0], pageNum, filter)
          .then(response => {
            cbSuccess(response)
          })
          .catch(error => {
            cbError(error)
          })
      }
    }
  }

  const Title = () => (
    <Typography className={classes.header}>Applications Tracker</Typography>
  )

  const renderContent = () => {
    return (
      <Box className={classes.layoutWrapper}>
        <ApplicationList
          applicationId={applicationId}
          setApplicationId={setApplicationId}
          getApplicationDetail={getApplicationDetail}
          applicationListDetails={applicationListDetails}
          getApplicationList={getApplicationList}
          setApplicationStatus={setApplicationStatus}
          programKey={programKey}
          familyKey={familyKey}
          workflow={workflow} />
        <ApplicationDetails
          applicationId={applicationId}
          setApplicationId={setApplicationId}
          applicationDetails={applicationDetails}
          getApplicationList={getApplicationList}
          setLoading={setLoading}
          errorCb={errorCb}
          applicationStatus={applicationStatus}
          setApplicationStatus={setApplicationStatus}
          successCb={successCb}
          programKey={programKey}
          familyKey={familyKey}
          utilityName={utilityName}
          workflow={workflow}
        />
      </Box>
    )
  }

  return (
    <Box>
      <Loader loading={loading} />
      <DisplayMessage open={open} message={message} messageType={messageType} handleClose={() => setOpen(false)} />
      <Breadcrumb value={applicationId ? [{ 'Dashboard': '/' }, { [programName]: `/applicationlist/${programId}`, search }, { 'Track Application': '' }] : [{ 'Dashboard': '/' }, { [programName]: '' }]} />
      <Title />
      <Cards className={classes.cardWrapper} children={renderContent()} />
    </Box>
  )
}

export default ApplicationTracker